import { render, staticRenderFns } from "./BillCenter.vue?vue&type=template&id=21fa3e34"
import script from "./BillCenter.vue?vue&type=script&lang=js"
export * from "./BillCenter.vue?vue&type=script&lang=js"
import style0 from "./BillCenter.vue?vue&type=style&index=0&id=21fa3e34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports